import React, { useState, useEffect } from "react";
import MorningBriefingDateDetailModal from "./MorningBriefingDateDetailModal";
import { commonService } from "../../../utils/commonService";
import { Table, Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import moment from "moment";
import Loader from "../../Loader/Loader";

const EventsAndCompressionRadar = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    EventsAndCompressionRadarTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [loadingOccData, setLoadingOccData] = useState(false);
  const eventListRef = React.useRef([]);

  const getEventList = async (sDate, eDate) => {
    let eventList = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
        body: {
          pageNum: 1,
          pageSize: 100,
          sortColumn: "",
          sortDirection: "asc",
          searchValue: "",
          propertyid: parseInt(para?.propertyDetail?.propertyid || 0),
          startdate: sDate ? sDate.format("YYYY-MM-DD") : null,
          enddate: eDate ? eDate.format("YYYY-MM-DD") : null,
          eventname: "",
          eventtypeterm: "",
          yearterm: ``,
        },
      },
      false,
    );

    let eventListResponse = apiResponse(false, eventList);

    if (eventListResponse?.isValidate) {
      let eventListArr = [];
      eventListResponse?.data?.data?.forEach((item) => {
        try {
          let singleEventObj = {
            id: item?.eventid ? item?.eventid : 0,
            name: item?.eventname,
            detail: item?.eventdetails,
            startDate: item?.startdate,
            endDate: item?.enddate,
            eventJson: item?.eventjson,
            eventResourceId: item?.eventsourceid,
          };
          let eventJsonData = "";
          if (item?.eventjson) {
            var decodedString = decodeURIComponent(item?.eventjson);
            const jsonStringWithoutQuotes = decodedString.slice(1, -1);
            const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
            eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
            let desc = eventJsonData?.description?.replaceAll("+", " ");
            singleEventObj = {
              ...singleEventObj,
              labels: eventJsonData?.labels ? eventJsonData?.labels : "",
              rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
              local_rank: eventJsonData?.local_rank
                ? eventJsonData?.local_rank
                : 0,
              phq_attendance: eventJsonData?.phq_attendance
                ? eventJsonData?.phq_attendance
                : 0,
              geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
              geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
              detail: desc,
            };
          }
          eventListArr.push(singleEventObj);
        } catch (err) {}
      });
      eventListRef.current = eventListArr;
    }

    if (!eventListResponse?.isValidate) {
      eventListRef.current = [];
    }
  };

  const getOccData = async () => {
    setLoadingOccData(true);
    const startDate = moment(para?.asOfDate || new Date());
    const endDate = moment(startDate).add(30, "days");

    await getEventList(startDate, endDate);

    let occDataResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.RATEIQ_YIELD.GET_OCCUPANCY_BY_DATES,
        body: {
          AsOfDate: para?.asOfDate,
          startDate: startDate.format("YYYY-MM-DD"),
          endDate: endDate.format("YYYY-MM-DD"),
          propertyCode: para?.propertyCode,
        },
      },
      false,
    );

    let response = apiResponse(false, occDataResponse);

    if (response?.isValidate) {
      let apiData = response?.data?.data || [];
      let eventsData = eventListRef.current || [];

      let formattedData = eventsData
        .filter((evt) => {
          let evtStart = moment(evt.startDate);
          return (
            evtStart.isSameOrAfter(startDate) &&
            evtStart.isSameOrBefore(endDate)
          );
        })
        .map((evt) => {
          let evtStartStr = moment(evt.startDate).format("YYYY-MM-DD");
          let matchOcc = apiData.find((item) => {
            let d = item.Dates;
            return d && moment(d).format("YYYY-MM-DD") === evtStartStr;
          });

          let datesStr = "";
          let evtStart = moment(evt.startDate);
          let evtEnd = moment(evt.endDate);
          if (evtStart.isSame(startDate, "day")) {
            datesStr = "Tonight";
          } else if (evtStart.isSame(evtEnd, "day")) {
            datesStr = evtStart.format("MMM D");
          } else {
            if (evtStart.format("MMM") === evtEnd.format("MMM")) {
              datesStr = `${evtStart.format("MMM D")}-${evtEnd.format("D")}`;
            } else {
              datesStr = `${evtStart.format("MMM D")} - ${evtEnd.format("MMM D")}`;
            }
          }

          let myBar = matchOcc?.BAR;
          let compAvg = matchOcc?.AVG_Compset;

          let isHighlighted = myBar > 0 && compAvg > 0 && myBar < compAvg;

          return {
            event: evt.name,
            dates: datesStr,
            ds: matchOcc.TotalDemandScore || matchOcc.TotalDemandScore || 0,
            otb: matchOcc ? (matchOcc?.RMS ? matchOcc?.RMS : 0) : 0,
            compAvg: compAvg,
            myBar: myBar,
            isHighlighted: isHighlighted,
            date: evtStartStr,
            ...matchOcc,
          };
        });

      formattedData.sort(
        (a, b) => moment(a.date).valueOf() - moment(b.date).valueOf(),
      );
      setData(formattedData);
    } else {
      setData([]);
    }
    setLoadingOccData(false);
  };

  useEffect(() => {
    if (api === 0) {
      const startDate = moment(para?.asOfDate || new Date());
      const staticEventData = [
        {
          event: "Annual Tech Conference",
          dates: "Tonight",
          ds: 92,
          otb: 85,
          compAvg: 220,
          myBar: 200,
          isHighlighted: true,
          date: startDate.format("YYYY-MM-DD"),
        },
        {
          event: "Summer Music Festival",
          dates:
            moment(startDate).add(5, "days").format("MMM D") +
            " - " +
            moment(startDate).add(7, "days").format("MMM D"),
          ds: 88,
          otb: 78,
          compAvg: 195,
          myBar: 185,
          isHighlighted: true,
          date: moment(startDate).add(5, "days").format("YYYY-MM-DD"),
        },
        {
          event: "City Marathon",
          dates: moment(startDate).add(12, "days").format("MMM D"),
          ds: 75,
          otb: 62,
          compAvg: 165,
          myBar: 170,
          isHighlighted: false,
          date: moment(startDate).add(12, "days").format("YYYY-MM-DD"),
        },
        {
          event: "Medical Expo",
          dates:
            moment(startDate).add(20, "days").format("MMM D") +
            " - " +
            moment(startDate).add(22, "days").format("MMM D"),
          ds: 80,
          otb: 70,
          compAvg: 180,
          myBar: 175,
          isHighlighted: true,
          date: moment(startDate).add(20, "days").format("YYYY-MM-DD"),
        },
      ];
      setData(staticEventData);
      setLoadingOccData(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getOccData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "EventsAndCompressionRadar",
                "emailIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.EventsAndCompressionRadarTable,
                  "EventsAndCompressionRadar",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId,
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "EventsAndCompressionRadar",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName:
                    compName?.EventsAndCompressionRadar ||
                    "EventsAndCompressionRadar",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "EventsAndCompressionRadar",
                "downloadIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              import={tblids.EventsAndCompressionRadarTable}
              src={downloadIcon}
              alt="menuIcon"
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.EventsAndCompressionRadarTable,
                  `${para?.propertyCode}-EventsAndCompressionRadar-${moment(new Date()).format("MMDDYYYY")}`,
                )
              }
            />
          </Button>
        </div>
      )}

      <div className="ViewPropertySetupTable mainTableClass">
        <div className="stripped__table">
          <div className="table-responsive tblDynamicPickupSticky">
            <Table
              id={tblids.EventsAndCompressionRadarTable}
              hover
              className="table-with-spacing positionStaticTable dailySummaryTbl"
            >
              <thead className="tbl-header-sticky">
                <tr className="diff-bg-tr table-main-header-tr">
                  <th className="border-right">EVENT</th>
                  <th className="border-right text-center">DATES</th>
                  <th className="border-right text-center">DS</th>
                  <th className="border-right text-center">OTB</th>
                  <th className="border-right text-end">COMP AVG</th>
                  <th className="border-right text-end">MY BAR</th>
                </tr>
              </thead>
              <tbody>
                {loadingOccData ? (
                  <tr style={{ height: "80px", position: "relative" }}>
                    <Loader />
                  </tr>
                ) : data.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="text-center p-4">
                      No Events Found
                    </td>
                  </tr>
                ) : (
                  data.map((row, i) => {
                    return (
                      <tr
                        key={i}
                        // id={commonService.generateGlobalClickTrackerID(
                        //   "EventsAndCompressionRadar",
                        //   "EventsAndCompressionRadar-row-click",
                        //   row.dates,
                        // )}
                      >
                        <td className="border-right">{row.event}</td>
                        <td className="border-right text-center">
                          {row.dates}
                        </td>
                        <td className="border-right text-center">
                          {commonService?.formateRoom(row.ds)}
                        </td>
                        <td className="border-right text-center">
                          {commonService?.formateRoom(row.otb)}
                        </td>
                        <td className="border-right text-end">
                          {commonService?.formateAmount(row.compAvg)}
                        </td>
                        <td className="border-right text-end">
                          {commonService?.formateAmount(row.myBar)}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={
            "EventsAndCompressionRadar" + tblids.EventsAndCompressionRadarTable
          }
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default EventsAndCompressionRadar;
